/**
 * Centralized route names enum
 * All route names should be defined here and referenced from routes
 * This ensures type safety and prevents typos
 */
export enum RouteNames {
  // System routes
  ROOT = "Root",
  NOT_FOUND = "NotFound",
  FORBIDDEN = "Forbidden",
  DONT_HAVE_PERMISSION = "DontHavePermission",

  // Auth routes
  LOGIN = "Login",
  FORGET_PASSWORD = "ForgetPassword",
  REST_PASSWORD = "ResetPassword",
  PASSWORD_CHANGE = "PasswordChange",

  // Core feature routes
  SOINSIGHTFUL = "SOInsightful",
  SALES_AND_TRAFFIC = "SalesAndTraffic",
  PRODUCT_RETURNS = "ProductReturns",
  ADVERTISING_SUMMARY = "AdvertisingSummary",
  ADVERTISING_PERFORMANCE = "AdvertisingPerformance",
  ADVERTISING_ANALYTICS = "AdvertisingAnalytics",
  REVIEWS = "Reviews",
  BRAND_PROTECTION = "BrandProtection",
  CAMPAIGNS = "Campaigns",
  INVENTORY = "Inventory",
  ALERTS = "ProductAlerts",
  PERFORMANCE = "ProductPerformance",
  HEALTH = "AccountHealth",
  WAREHOUSE = "Warehouse",
  CUSTOMER_ANALYTICS = "CustomerAnalytics",
  ZINUS_CALCULATOR = "ZinusCalculator",
  FUNNEL_PERFORMANCE = "FunnelPerformance",
  PRODUCT_REVIEWS = "ProductReviews",
  COMMUNICATION = "Communication",
  PROFIT_ANALYSIS = "ProfitAnalysis",
  COMPETITOR = "Competitor",
  CATEGORY = "CategoryAnalysis",

  // Admin routes
  USERS = "Users",
  EDIT_USER = "EditUser",
}
